module.exports = __webpack_public_path__ + "img/az.39527be0.svg";